import React from 'react';
import TimeAgo from 'react-timeago';
import Switch from 'react-switch';
import colors from 'Styles/colors';
import { SwitchContainer } from 'Screens/Contextualization/Workspaces/components/Table/styled';
import { Status } from '../Grid/components/UserAgents/components/UserAgent/styled';
import { CategoriesCell, CheckColum, CheckHeader, NameCell } from './components/columns';

/**
 * User agents (runners) table.
 * ctx: `{ isFetching, show, intl, isAdmin, onChangeState(agent) }`
 */
const agentsSchema = {
  id: 'agents',
  loading: { mockRows: 13, skeleton: ({ isFetching }) => isFetching },
  columns: [
    {
      header: (_, { show }) => <CheckHeader disabled={ show } />,
      id: 'selected',
      accessor: 'selected',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: ({ original }, { show }) => <CheckColum agent={ original } disabled={ show } />
    },
    {
      header: 'Name',
      accessor: 'name',
      id: 'name',
      visible: true,
      sortable: true,
      cell: ({ original }) => <NameCell agent={ original } />
    },
    {
      header: 'Status',
      accessor: 'status',
      id: 'status',
      visible: true,
      sortable: false,
      maxWidth: 150,
      minWidth: 150,
      cell: ({ value }, { intl }) => {
        const statusLabel = value ? intl.formatMessage({ id: `agents.item.status.${value}` }) : 'Online';
        return <Status value={ value || 'online' } children={ statusLabel } noMargin />;
      }
    },
    {
      header: 'Last Executed',
      accessor: 'last_run',
      id: 'last_run',
      visible: true,
      sortable: false,
      cell: ({ value }) => <TimeAgo date={ value } />
    },
    {
      header: 'Blocked',
      accessor: 'active',
      id: 'active',
      visible: true,
      sortable: true,
      cell: ({ original, value }, { isAdmin, onChangeState }) => (
        <SwitchContainer checked={ value }>
          <Switch
            checked={ !value }
            onChange={ () => { onChangeState(original); } }
            onColor={ colors.green4 }
            offColor={ colors.grey14 }
            onHandleColor={ colors.green3 }
            offHandleColor={ colors.grey15 }
            boxShadow="0 0 4px 0 rgba(83, 83, 83, 0.5)"
            activeBoxShadow=""
            height={ 14 }
            width={ 39 }
            handleDiameter={ 21 }
            uncheckedIcon={ false }
            checkedIcon={ false }
            disabled={ !isAdmin }
          />
        </SwitchContainer>
      )
    },
    {
      header: 'Description',
      accessor: 'description',
      id: 'description',
      visible: true,
      sortable: true,
      minWidth: 150,
      cell: ({ value }) => <div style={ { color: '#90a9c0', fontSize: '14.5px' } }>{value}</div>
    },
    {
      header: 'Categories',
      accessor: 'category',
      id: 'category',
      visible: true,
      sortable: false,
      minWidth: 150,
      cell: ({ original }) => <CategoriesCell agent={ original } />
    }
  ]
};

export default agentsSchema;
